import { useContext } from 'react'
import { MarkupContext } from '../../providers/Markup'
import themeConfig from '../../../theme.config'
import { HomeIcon, SlashIcon } from '@heroicons/react/24/solid'
import { dataLayerPush } from '../../helpers/thirdparty'

function Breadcrumbs(props) {
  const { detectPaletteClass } = useContext(MarkupContext)

  if (!props.items?.length) {
    return
  }

  // The Article Header stacks into its mobile layout below lg and the design has
  // no breadcrumbs there, so it opts into hiding below lg (rather than the
  // default md) and into dropping the divider border.
  const hideClass = props.hideBelowLg ? 'max-lg:hidden' : 'max-md:hidden'
  const borderClass = props.noBorder ? '' : 'border-y-2 border-gray-200'

  const textClass = 'font-highlight text-sm font-medium leading-5 text-(--Colours-brand-primary-NDS-90-Percent-Black)'

  return (
    <nav aria-label="breadcrumb navigation" className={hideClass}>
      <ul
        className={detectPaletteClass(
          `bg-${themeConfig.settings.nav.breadcrumbs.base} ${borderClass} !text-(--sb-${themeConfig.settings.nav.breadcrumbs.base}-text) -xs font-medium flex`,
        )}
      >
        {props.items.map((item, i) => {
          const isLast = i === props.items.length - 1

          return (
            <li key={i} className="flex items-center">
              {(item.disablePageLinkInMegaMenu || isLast) ? (
                <span
                  aria-current={isLast ? 'page' : undefined}
                  className={`px-4 py-3 flex items-center ${textClass}`}
                >
                  {i === 0 && (
                    <>
                      <HomeIcon
                        className={detectPaletteClass(
                          `h-6 w-6 !text-(--sb-${themeConfig.settings.nav.breadcrumbs.base}-text)`,
                        )}
                        aria-label="Home"
                        role="none"
                      />
                      <span className="sr-only">Home</span>
                    </>
                  )}
                  {i > 0 && item.label}
                </span>
              ) : (
                <a
                  href={item.url}
                  className={`group px-4 py-3 flex items-center ${i > 0 ? 'hover:underline underline-offset-4 decoration-current hover:decoration-current' : ''} ${textClass}`}
                  onClick={() => {
                    dataLayerPush({
                      event: 'navigation_breadcrumb_click',
                      click_text: item.label,
                      destination_path: item.url,
                    })
                  }}
                >
                  {i === 0 && (
                    <span className="inline-flex underline-offset-4 decoration-current group-hover:underline group-focus-visible:underline">
                      <HomeIcon
                        className={detectPaletteClass(
                          `h-6 w-6 !text-(--sb-${themeConfig.settings.nav.breadcrumbs.base}-text)`,
                        )}
                        aria-hidden="true"
                      />
                      <span className="sr-only">Home</span>
                    </span>
                  )}
                  {i > 0 && item.label}
                </a>
              )}
              {!isLast && <SlashIcon className="h-5 w-5 text-gray-300" />}
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Breadcrumbs
